const step1DefaultState = {
  dotListForDropdown: [],
  locationSearchQuery: '',
  selection: null,
  byDOTNumberSelectionValues: [],
  byLocationNameSelectionValues: []
};

export default step1DefaultState;